<div class="header animated fadeIn">
   <p>Confirmacíon de recursos</p>
   <img (click)="close()" class="my-auto cursor-pointer" height="13" src="assets/icon/x.svg" alt="close">
</div>

<div class="body fs-body animated fadeIn p-0">
   <div class="d-block m-auto d-sm-flex align-items-sm-center">
      <div class="col-12 col-sm-4 image-s">
         <img [src]="buildImageUrl(infoAmount, urlBaseS3)" alt="Image Project" class="w-100">
      </div>
      <div class="col-12 col-sm-8 info-s px-3 pb-3">
         <div class="table-responsive mt-3">

            <p> Al aceptar los recursos recaudados, éstos serán transferidos directamente a la cuenta CLABE asociada a
               tu proyecto. </p>

            <p> Una vez que los fondos sean depositados, tendrás la libertad de retirarlos según tus necesidades. </p>

            <p> Apreciamos tu confianza y estamos comprometidos a hacer este proceso lo más transparente y sencillo
               posible. </p>

            <p> Si tienes alguna pregunta o inquietud respecto a esta transacción, no dudes en contactarnos.</p>

            <table class="table table-bordered align-middle">
               <tbody>
                  <tr class="title-table">
                     <td colspan="3" class="title-table">
                        <p class="m-0 fs-16">{{ infoAmount.name }} - Desglose de gastos </p>
                     </td>
                  </tr>
                  <tr>
                     <th class="tr-tags">Ítem</th>
                     <th class="tr-tags">Porcentaje</th>
                     <th class="tr-tags">Monto</th>
                  </tr>
                  <tr>
                     <th class="tr-title">Monto disponible</th>
                     <th class="tr-desc">-</th>
                     <th class="tr-desc">{{ amountToWithdraw | currency: '$'}}</th>
                  </tr>
                  <tr>
                     <th class="tr-title">Comisión por fondeo</th>
                     <th class="tr-desc">{{ percentCommission | percent: '1.1-2' }}</th>
                     <th class="tr-desc">{{ commission | currency: '$' }}</th>
                  </tr>
                  <tr>
                     <th class="tr-title">I.V.A</th>
                     <th class="tr-desc">16 %</th>
                     <th class="tr-desc">{{ ivaTotal | currency: '$' }}</th>
                  </tr>
                  <tr>
                     <th class="tr-title fw-bold">Monto neto</th>
                     <th class="tr-desc">-</th>
                     <th class="tr-desc fw-bold">{{ amountNetFinal | currency: '$' }}</th>
                  </tr>
               </tbody>
            </table>
         </div>
         <p class="text-end fw-bold fs-13 pt-3">¿Deseas confirmar la operación?</p>
         <div class="d-flex align-items-center justify-content-end mt-3">
            <button mat-button class="invert" (click)="close()">Cancelar</button>
            <button mat-button class="ms-3" (click)="openModalAcceptResources()">Aceptar</button>
         </div>
      </div>
   </div>
</div>
